import { Module } from "vuex";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { ScenariosState } from "./types";
import { RootState } from "../types";

export const state: ScenariosState = {
    actions: [],
};

const namespaced: boolean = true;

export const scenarios: Module<ScenariosState, RootState> = {
    namespaced,
    state,
    getters,
    mutations,
};
